<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterServiceTicket" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Service Record</mat-label>
          <input placeholder="Service Record"
            matInput
            [matChipInputFor]="chipServiceRecords"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'servicerecords')">
          </mat-form-field>
          <mat-chip-grid #chipServiceRecords>
            @for (item of serviceRecords; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'servicerecords')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Unit Id</mat-label>
            <input placeholder="Unit Id"
              matInput
              [matChipInputFor]="chipUnitId"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
            </mat-form-field>
            <mat-chip-grid #chipUnitId>
              @for (item of unitIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'unitids')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Technician Name</mat-label>
              <input placeholder="Technician Name"
                matInput
                [matChipInputFor]="chipTechnicianNames"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'techniciannames')">
              </mat-form-field>
              <mat-chip-grid #chipTechnicianNames>
                @for (item of technicianNames; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'techniciannames')">
                    {{item}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-actions">
              <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                {{ changeTypeButton() ? 'Reset' : 'Filter' }}
              </button>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>